import { IAccessibilityMenuLabelsOptions } from '../interfaces/accessibility.interface';

export const ptBRLabels: IAccessibilityMenuLabelsOptions = {
  resetTitle: 'Resetar',
  closeTitle: 'Fechar',
  menuTitle: 'Menu de Acessibilidade',
  increaseText: 'Aumentar texto',
  increaseTextSpacing: 'Aumentar espaçamento',
  invertColors: 'Inverter cores',
  grayHues: 'Tons de cinza',
  bigCursor: 'Cursor grande',
  readingGuide: 'Guia de leitura',
  underlineLinks: 'Sublinhar links',
  textToSpeech: 'Texto para fala',
  disableAnimations: 'Desativar animações',
  increaseLineHeight: 'Aumentar altura de linha',
  hotkeyPrefix: 'Atalho: ',
  hotkeysHelpTitle: 'Atalhos de teclado',
  dyslexicFont: 'Fonte para dislexia',
  hideImages: 'Ocultar imagens',
};
